"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./Message.scss");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _rdsIcons = require("@ruter-ds/rds-icons");

var _excluded = ["closable", "title", "text", "children", "skin", "hasBorder", "icon", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var propTypes = {
  skin: (0, _propTypes.oneOf)(['success', 'warning', 'danger', 'info']).isRequired,

  /** The message title */
  title: _propTypes.string,

  /**
   * @deprecated Use `children`instead
   */
  text: _propTypes.string,

  /** Content as children */
  children: _propTypes.node,

  /** Choose the icon you want on your message. (The message can be displayed without an icon). */
  icon: _propTypes.element,

  /** Makes the message closable with a close button (X) in the upper right corner */
  closable: _propTypes.bool,

  /** Choose if the message has a border or not */
  hasBorder: _propTypes.bool,

  /** Callback function that fires when the message is closing */
  onClose: _propTypes.func,

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  onClose: function onClose() {},
  hasBorder: true
};
/**
 * The Message component is a container for displaying temporary and/or urgent information that may be important for the user.
 */

var Message = /*#__PURE__*/function (_Component) {
  _inherits(Message, _Component);

  var _super = _createSuper(Message);

  function Message(props) {
    var _this;

    _classCallCheck(this, Message);

    _this = _super.call(this, props);
    _this.closeMessage = _this.closeMessage.bind(_assertThisInitialized(_this));
    _this.state = {
      showMessage: true
    };
    return _this;
  }

  _createClass(Message, [{
    key: "closeMessage",
    value: function closeMessage(event) {
      var _this2 = this;

      this.setState({
        showMessage: false
      }, function () {
        _this2.props.onClose(event);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          closable = _this$props.closable,
          title = _this$props.title,
          text = _this$props.text,
          children = _this$props.children,
          skin = _this$props.skin,
          hasBorder = _this$props.hasBorder,
          icon = _this$props.icon,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var showMessage = this.state.showMessage;
      var componentClassNames = (0, _classnames.default)('rds-message', {
        'rds-message--default': skin === 'default' || skin === '',
        'rds-message--success': skin === 'success',
        'rds-message--warning': skin === 'warning',
        'rds-message--danger': skin === 'danger',
        'rds-message--info': skin === 'info',
        'rds-message--has-border': hasBorder
      }, className);
      return showMessage && /*#__PURE__*/_react.default.createElement("div", _extends({
        className: componentClassNames
      }, rest), icon && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        component: icon,
        className: "rds-message__icon"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "rds-message__content"
      }, title && /*#__PURE__*/_react.default.createElement("h2", {
        className: "rds-message__title"
      }, title), (text || children) && /*#__PURE__*/_react.default.createElement("div", {
        className: "rds-message__text"
      }, text && /*#__PURE__*/_react.default.createElement("p", null, text), children)), closable && /*#__PURE__*/_react.default.createElement("button", {
        className: 'rds-message__close',
        onClick: this.closeMessage,
        "aria-label": "Lukk"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "rds-is-vishidden"
      }, "Lukk"), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        component: /*#__PURE__*/_react.default.createElement(_rdsIcons.CrossIcon, null),
        size: "small"
      })));
    }
  }]);

  return Message;
}(_react.Component);

Message.propTypes = propTypes;
Message.defaultProps = defaultProps;
var _default = Message;
exports.default = _default;